"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _classnames3 = require("classnames");

var _classnames4 = _interopRequireDefault(_classnames3);

var _components = require("components");

var _Button = require("../components/Button");

var _Button2 = _interopRequireDefault(_Button);

var _TextButton = require("../components/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _TrialWelcomePopup = require("./TrialWelcomePopup/TrialWelcomePopup");

var _TrialWelcomePopup2 = _interopRequireDefault(_TrialWelcomePopup);

var _TrialExpiredPopup = require("./TrialExpiredPopup/TrialExpiredPopup");

var _TrialExpiredPopup2 = _interopRequireDefault(_TrialExpiredPopup);

var _TrialCutomPopup = require("./TrialCutomPopup/TrialCutomPopup");

var _TrialCutomPopup2 = _interopRequireDefault(_TrialCutomPopup);

var _styles = require("./styles.scss");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var textButton = (0, _glamor.css)({
  marginLeft: 2,
  marginRight: 2,
  "& button": {
    margin: 0,
    fontFamily: "Roboto, Source Sans Pro, sans-serif;",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px"
  }
});

var TrailPopup = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(TrailPopup, _React$Component);

  function TrailPopup() {
    (0, _classCallCheck3.default)(this, TrailPopup);
    return (0, _possibleConstructorReturn3.default)(this, (TrailPopup.__proto__ || (0, _getPrototypeOf2.default)(TrailPopup)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrailPopup, [{
    key: "render",
    value: function render() {
      var _classnames,
          _classnames2,
          _this2 = this;

      var _props = this.props,
          onCloseYes = _props.onCloseYes,
          onTrialClick = _props.onTrialClick;

      var megascans = (0, _classnames4.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, _styles2.default["icon"], true), (0, _defineProperty3.default)(_classnames, _styles2.default["megascans"], true), _classnames));

      var footerContainer = (0, _classnames4.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, _styles2.default["container"], true), (0, _defineProperty3.default)(_classnames2, _styles2.default["footer"], true), _classnames2));

      var unrealEngineButtonProps = {
        label: "Access to legacy Megascans library",
        onClick: function onClick() {
          var router = _this2.context.router;

          router.push({
            pathname: "/epic-migration",
            state: { modal: true }
          });
          onCloseYes();
        },
        primary: true,
        fullWidth: true,
        disabled: false
      };

      var freeTrial = {
        label: "Start Free Trial",
        onClick: function onClick() {
          onTrialClick();
        },
        primary: true,
        fullWidth: true,
        disabled: false
      };

      return _react2.default.createElement(
        _components.Popup,
        null,
        _react2.default.createElement(
          _components.Popup.Header,
          null,
          "Choose a plan"
        ),
        _react2.default.createElement(
          _components.Popup.Content,
          null,
          _react2.default.createElement(
            "div",
            { className: _styles2.default.container },
            _react2.default.createElement(
              "div",
              { className: _styles2.default.iconContainer },
              _react2.default.createElement("span", { className: megascans }),
              _react2.default.createElement(
                "span",
                { className: _styles2.default.icon },
                _react2.default.createElement(
                  "svg",
                  {
                    width: "32",
                    height: "32",
                    viewBox: "0 0 32 32",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg" },
                  _react2.default.createElement("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM20.0925 24.8953C24.005 23.0474 25.2316 19.6345 25.5076 18.3049C24.0772 19.77 22.4944 21.2549 21.43 20.227C21.43 20.227 21.3716 14.7407 21.3716 12.4912C21.3716 9.46606 24.2404 7.21157 24.2404 7.21157C22.6626 7.49252 20.7682 8.05441 18.757 10.0279C18.5755 10.2078 18.4035 10.397 18.2416 10.5948C17.38 9.93496 16.2631 10.1328 16.2631 10.1328C16.8666 10.4642 17.469 11.4297 17.469 12.229V20.0856C17.469 20.0856 16.1533 21.243 15.1394 21.243C14.9108 21.2447 14.6852 21.1917 14.4812 21.0884C14.2773 20.9852 14.101 20.8347 13.9671 20.6494C13.8868 20.5446 13.8203 20.4299 13.7693 20.3082V10.6017C13.4695 10.849 12.4565 11.0528 12.4565 9.37109C12.4565 8.32645 13.2094 7.08099 14.5498 6.3173C12.7091 6.59798 10.9851 7.39323 9.57686 8.61135C8.50692 9.53597 7.65118 10.6825 7.06915 11.9713C6.48712 13.2601 6.19275 14.6602 6.20652 16.0742C6.20652 16.0742 7.18685 13.0115 8.4145 12.7286C8.59337 12.6815 8.78077 12.6768 8.96176 12.715C9.14274 12.7531 9.31231 12.833 9.45693 12.9484C9.60155 13.0637 9.71723 13.2112 9.79473 13.3791C9.87223 13.5471 9.90941 13.7308 9.90331 13.9157V21.1075C9.90331 21.8365 9.43342 21.9958 8.99915 21.9879C8.70495 21.9672 8.41414 21.9124 8.13257 21.8247C9.02905 23.038 10.194 24.0276 11.5363 24.7161C12.8786 25.4046 14.362 25.7733 15.8704 25.7935L18.5216 23.1285L20.0925 24.8953Z",
                    fill: "white" })
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.heading },
              "Use with unreal engine"
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.para },
              "If you will be working with Unreal Engine based products, we can set you up with our Unreal Unlimited plan, giving you free unlimited access to the entire Megascans library to use with Unreal Engine."
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.actionButton },
              _react2.default.createElement(_Button2.default, unrealEngineButtonProps)
            )
          )
        ),
        _react2.default.createElement(
          _components.Popup.Footer,
          null,
          _react2.default.createElement(
            "div",
            { className: footerContainer },
            _react2.default.createElement(
              "div",
              { className: _styles2.default.iconContainer },
              _react2.default.createElement("span", { className: megascans })
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.heading },
              "Use with anything"
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.para },
              "Includes access to the free section of Megascans library. If you\u2019d like to use Megascans with tools other than Unreal Engine, then you can try out Megascans for 30 days, before you choose to switch to one of our",
              _react2.default.createElement(_TextButton2.default, {
                className: textButton,
                type: "button",
                label: "Pricing Plans.",
                mode: "small-normal",
                to: "/pricing",
                onClick: onCloseYes
              })
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.actionButton },
              _react2.default.createElement(_Button2.default, freeTrial)
            )
          )
        )
      );
    }
  }]);
  return TrailPopup;
}(_react2.default.Component), _class.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp);

TrailPopup.Expired = _TrialExpiredPopup2.default;
TrailPopup.Welcome = _TrialWelcomePopup2.default;
TrailPopup.Custom = _TrialCutomPopup2.default;
exports.default = TrailPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicEula/TrialPopup/index.jsx
// module id = 2828
// module chunks = 0